import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
// import { BrowserTracing } from '@sentry/tracing';
import { BrowserRouter as Router } from 'react-router-dom';
import './style.scss';
import { I18nextProvider } from 'react-i18next';
import HTTPBackend from 'i18next-http-backend';
import i18next from 'i18next';
import App from './app';
import { APP_TYPES, APP_TYPES_NAMES } from './apiLogic/constants';

// Enable Sentry SDK
Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_FEATURE ? process.env.NODE_ENV.concat('-', process.env.REACT_APP_FEATURE) : process.env.NODE_ENV,
    // integrations: [new BrowserTracing({
    //     tracePropagationTargets: ['ords-sandbox.fd.pens.com', 'service.pens.com']
    // })],
    tracesSampleRate: 0.2,
    beforeSend: (event) => {
        return window.location.hostname === 'localhost' ? null : event; 
    },
});
// set tags
Sentry.setTag('lambda', 'website-payments-app');
Sentry.setTag('version', 'v1');
Sentry.setTag('memory_size', 'empty');
Sentry.setTag('log_group', 'prepayment');

function featureTag() {
    console.log(`You are currently on feature: ${process.env.REACT_APP_FEATURE}`);
    return <span className="feature-tag">Feature</span>;
}

const FEATURE_TAG = process.env.REACT_APP_FEATURE ? featureTag() : null;

const APP_MODE = () => {
    try {
        let res;
        if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_PORTAL_LOCAL) {
            res = Object.keys(APP_TYPES).find((key) => {
                return APP_TYPES[key] === process.env.REACT_APP_PORTAL_LOCAL ;
            });
            if (res === APP_TYPES_NAMES.SELF_PAYMENT) {
                return APP_TYPES_NAMES.INVOICE_POST_PAYMENT;
            }
            else if (res === APP_TYPES_NAMES.SIMPLY_GOLDSTAR) {
                return APP_TYPES_NAMES.SIMPLY_GOLDSTAR;
            }
        } else {
            if (window.location.origin.includes(APP_TYPES.PENS_COM) && window.location.pathname.includes('ord/')) {
                return APP_TYPES_NAMES.NEW_ORDER_PAYMENT;
            }
            if (window.location.origin.includes(APP_TYPES.PENS_COM) && window.location.pathname.includes('cust/')) {
                return APP_TYPES_NAMES.ONE_FLOW_PAYMENT;
            }
            if (window.location.hostname.includes(APP_TYPES.FOR_TEACHERS_ONLY)) {
                return APP_TYPES_NAMES.FOR_TEACHERS_ONLY;
            }
            if (window.location.hostname.includes(APP_TYPES.SIMPLY_GOLDSTAR)) {
                return APP_TYPES_NAMES.SIMPLY_GOLDSTAR;
            }
            if(!window.location.hostname.includes(APP_TYPES.SERVICE_PENS_COM)){
                return APP_TYPES_NAMES.INVOICE_POST_PAYMENT;
            }

            res = Object.keys(APP_TYPES).find(key => {
                const hostName = window.location.hostname.split('.')[0] ;
                if(hostName.includes('-')){
                    return hostName.split('-')[1] === APP_TYPES[key] ;
                } else {
                    return hostName === APP_TYPES[key];
                }
            })

            if (res === APP_TYPES_NAMES.PRE_PAYMENT || res === APP_TYPES_NAMES.ORDER_PAYMENT) {
                if (window.location.search.includes('refid')) {
                    return APP_TYPES_NAMES.PRE_PAYMENT;
                } else {
                    return APP_TYPES_NAMES.ORDER_PAYMENT;
                }
            }

            if((res === APP_TYPES_NAMES.SELF_PAYMENT)){
                return APP_TYPES_NAMES.INVOICE_POST_PAYMENT
            } else if (res === APP_TYPES_NAMES.SIMPLY_GOLDSTAR) {
                return APP_TYPES_NAMES.SIMPLY_GOLDSTAR;
            }
        }
        return res;
    } catch(ex){
        return APP_TYPES.PRE_PAYMENT;
    }
};

const appType = APP_TYPES[APP_MODE()] ;

if (appType === APP_TYPES.INVOICE_POST_PAYMENT) {
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${process.env.REACT_APP_RECAPTCHA_CLIENT}`;
    document.body.appendChild(script);
}

const i18appType = appType === APP_TYPES.NEW_ORDER_PAYMENT ? APP_TYPES.ORDER_PAYMENT : appType;
const i18nextOptions = {
    ns: ['common_invoice','common_order'],
    defaultNS: ['translation'],
    interpolation: { escapeValue: false }, 
    backend: {
        loadPath: `${process.env.PUBLIC_URL}/locales/${i18appType}/{{lng}}/{{ns}}.json`
    }
}

window.$appName = appType ;
i18next
  .use(HTTPBackend)
  .init(i18nextOptions)
    ReactDOM.render(
      <Router>
        <I18nextProvider i18n={i18next}>
          <Suspense fallback={<></>}>
            {FEATURE_TAG}
            <App />
          </Suspense>
        </I18nextProvider>
      </Router>,
      document.getElementById("root")
  );
